import {Pipe, PipeTransform} from '@angular/core';
import { EMOJI_DICTIONARY, EMOJI_NAMES, emojiSVGPath } from '../models/emoji.model';

@Pipe({
    name: 'emoji'
})
export class EmojiPipe implements PipeTransform {
    replacements = EMOJI_NAMES.map((emojiName) =>
        ({key: new RegExp(`:${emojiName}:`, "g"), value: `<img src="${emojiSVGPath(emojiName)}" alt="${EMOJI_DICTIONARY[emojiName].emoji}" aria-label="${EMOJI_DICTIONARY[emojiName].emoji}" data-emoji="${EMOJI_DICTIONARY[emojiName].emoji}" width="27">`})
    );

    transform(value: any, args?: any): any {
        for (const i in this.replacements) {
            value = value.replace(this.replacements[i].key, this.replacements[i].value);
        }
        return value;
    }
}
